// extracted by mini-css-extract-plugin
export default {"carousel":"styles_carousel__6znFY","carouselItem":"styles_carouselItem__gL7Hm","carouselImage":"styles_carouselImage__ycZDU","iconContainer":"styles_iconContainer__8gw8G"};